import React from "react";
import { default as MUITableRow } from "@mui/material/TableRow";
import styled from "styled-components";

const StyledMUITableRow = styled(MUITableRow)``;

export const TableRow = (props) => {
  return <StyledMUITableRow {...props} />;
};
